import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AreasService } from "../../master-services/area-services/areas.service";
import { Router } from "@angular/router";
import swal from "sweetalert2";

@Component({
  selector: "app-master-area",
  templateUrl: "./master-area.component.html",
  styleUrls: ["./master-area.component.scss"],
})
export class MasterareaComponent implements OnInit {
  myForm: FormGroup;
  areas: any;
  submitted = false;
  areaUpdate: any;
  userProfile: number = 0;


    constructor(private AreasService: AreasService , private router: Router ) {
      this.userProfile = Number(localStorage.getItem('profile'));
    const id = new FormControl("");
    const nameArea = new FormControl("", Validators.required);
    const description = new FormControl("");
    this.myForm = new FormGroup({
      id: id,
      nameArea: nameArea,
      description: description,
    });
    this.getArea();
  }

  ngOnInit() {}
  get checkForm() {
    return this.myForm.controls;
  }
  //Genera el listado de la tabla
  getArea() {
    this.AreasService.getArea()
      .then((data) => {
        const resp: any = data;
        if (this.userProfile === 3) {
          this.areas = resp.data.filter(area => area.id === 16);
        } else {
          this.areas = resp.data;
        }
        swal.close();
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  // Genera la información, según el id seleccionado
  getAreaById(id) {
    this.AreasService.areaById(id)
      .then((data) => {
        const resp: any = data;
        this.areaUpdate = resp.data;
        this.setForm(this.areaUpdate);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  //Muestra la información del dato seleccionado
  setForm(areaUpdate: any) {
    this.myForm.get("id").setValue(areaUpdate[0].id);
    this.myForm.get("nameArea").setValue(areaUpdate[0].name_area);
    this.myForm.get("description").setValue(areaUpdate[0].description);
  }

  //Limpia el formulario
  clearform() {
    this.myForm.get("id").setValue(0);
    this.myForm.get("nameArea").setValue("");
    this.myForm.get("description").setValue("");
  }

  //Eliminar (cambiar estado)
  delete(id) {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.AreasService.delete(id).then((data) => {
      const resp: any = data;

      if (resp.success === false) {
        swal({
          title: "Mensaje ",
          text: resp.message,
          type: "error",
        });
      } else {
        swal({
          title: "ok",
          type: "success",
        });
      }
    });

    this.getArea();
  }

  // Almacena las baterías
  strageArea() {
    if (!this.myForm.invalid) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();

      this.AreasService.strageArea(
        this.myForm.get("id").value,
        this.myForm.get("nameArea").value,
        this.myForm.get("description").value
      )
        .then((data) => {
          const resp: any = data;
          if (resp.success === false) {
            swal({
              title: "Mensaje ",
              text: resp.message,
              type: "error",
            });
          } else {
            swal({
              title: "Tercero agregado",
              type: "success",
            });
          }
        })
        .catch((error) => {
          // console.log(error);
        });
      this.getArea();
      this.clearform();
    }
  }

  managearea(id: any) {

    this.router.navigateByUrl('erp/manageArea/' + id);
    localStorage.removeItem('idarea');
    localStorage.setItem('idarea', id)

  }
}



// WEBPACK FOOTER //
// ./src/app/master/master-area/master-area.component.ts